'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.createStyleSheet = createStyleSheet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStyleSheet(name, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var styleSheet = {
    name: name,
    options: options,
    createRules: createRules
  };

  function createRules() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var rules = typeof callback === 'function' ? callback(theme) : callback;

    if (!theme.overrides || !theme.overrides[name]) {
      return rules;
    }

    var overrides = theme.overrides[name];
    var rulesWithOverrides = (0, _extends3.default)({}, rules);

    (0, _keys2.default)(overrides).forEach(function (n) {
      rulesWithOverrides[n] = (0, _assign2.default)(rulesWithOverrides[n] || {}, overrides[n]);
    });

    return rulesWithOverrides;
  }

  return styleSheet;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/jss-theme-reactor/styleSheet.js
// module id = 772
// module chunks = 32